import React, { Component } from 'react';

import Events from './Events';
import OddsDropdown from './OddsDropdown';
import RedCards from './RedCards';
import Odd from './Odd';

const goalSound = new Audio('https://www.betarades.gr/wp-content/themes/betarades/assets/sounds/goal.mp3');

class GameRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oddsDropdownActive: false
    };

    this.onToggleOdds = this.onToggleOdds.bind(this);
    this.handleCloseOdds = this.handleCloseOdds.bind(this);
  }

  componentDidMount(){
    if ( ("Notification" in window) && Notification.permission !== "denied") {
      //  ask the user for permission to notifications
      Notification.requestPermission(function (permission) {});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    var doUpdate = false;

    if( (nextProps.selected !== this.props.selected) // Render if selected is changed
        || (nextProps.G !== this.props.G) // Render if Game info is changed
        || (nextState.oddsDropdownActive !== this.state.oddsDropdownActive)) // Render if odds drop is open
      doUpdate = true;

    return doUpdate;
  }

  onToggleOdds() {
    this.setState({
      oddsDropdownActive: !this.state.oddsDropdownActive
    })
  }

  handleCloseOdds() {
    this.setState({
      oddsDropdownActive: false
    })
  }

  goalNotification(title="ΓΚΟΛ!", bodyMsg="Μπήκε goal") {
    // let notificationArgs = {
    //   'body' : bodyMsg,
    // }

    // Let's check if the browser supports notifications
    if (!("Notification" in window)) {
      console.log("This browser does not support notification");
    }
    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === "granted") {
      // If it's okay let's create a notification
      // var notification = new Notification(title, notificationArgs);
    }
    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== "denied") {
      Notification.requestPermission(function (permission) {
        // If the user accepts, let's create a notification
        // if (permission === "granted") {
        //   var notification = new Notification(title, notificationArgs);
        // }
      });
    }
  }

  render() {
    const FLAGS_EXT = '.svg';
    const flagsCdn = 'https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/';
    const G = this.props.G;
    const IS_STARTED = G.isLive || G.isFinished;
    const IS_CANCELED = G.isPP || G.isAB;
    const HAS_EVENTS = G.events !== '';
    const NO_FEED = G.live === '0' && !G.isFinished;
    const PREVIEW_EXISTS = G.hasOwnProperty('preview') && ( G.preview.slug !== null || G.preview.slug !== undefined );
    const SELECTED_GAMES = localStorage.getItem('selectedGames') ? localStorage.getItem('selectedGames').split(',').splice(1) : null;

    const dArrow = PREVIEW_EXISTS && !this.props.isExternal ? 'fa fa-blue fa-arrow-circle-down' : 'fa fa-angle-down';
    const uArrow = PREVIEW_EXISTS && !this.props.isExternal ? 'fa fa-blue fa-arrow-circle-up' : 'fa fa-angle-up';
    const otherOddsBtnClass = !this.state.oddsDropdownActive ? dArrow : uArrow;

    let rowClass = G.isPP ? 'pp' : '';
        rowClass += NO_FEED ? ' nofeed' : '';
        rowClass += this.props.selected ? ' selected' : '';

    let liveFTScoreClass = G.isLive ? (G.isHT ? 'score-cell score ft live' : 'score-cell score ft live HT') : (IS_CANCELED ? 'score-cell score ft canceled' : 'score-cell score ft');
        liveFTScoreClass += !this.props.res.isMobile && HAS_EVENTS ? ' has_events' : '';

    let liveResultClass = G.isLive && !G.isHT ? 'general-cell cond minute' : 'general-cell cond';
        liveResultClass += ( G.teams.awayteam.scored || G.teams.hometeam.scored ) ? ' scored' : '';
        liveResultClass += ( G.isHT ) ? ' half' : '';

    // teams classes
    let homeTeamClass = G.teams.hometeam.winning ? 'bold' : '';
        homeTeamClass += G.teams.hometeam.scored ? ' scored' : '';
        homeTeamClass += ' team-cell team teamA';

    let awayTeamClass = G.teams.awayteam.winning ? 'bold' : '';
        awayTeamClass += G.teams.awayteam.scored ? ' scored' : '';
        awayTeamClass += ' team-cell team teamB';


    // Play sounds
    if( G.teams.awayteam.scored || G.teams.hometeam.scored ){
      // eslint-disable-next-line no-unused-expressions
      this.props.soundEnabled ? goalSound.play() : null;

      //push notification when a goal is scored in selected matches
      if ( SELECTED_GAMES && SELECTED_GAMES.indexOf(G.id) !== -1 ) {
        let scoreTitle = 'ΓΚΟΛ!';
        let scoreBody = '';
        if (G.teams.awayteam.scored) {
          scoreBody = G.teams.awayteam.name;
        }
        else if (G.teams.hometeam.scored) {
          scoreBody = G.teams.hometeam.name;
        }
        this.goalNotification( scoreTitle, scoreBody);
      }
    }


    // Limit word letters
    // On mobile portrait
    let TEAM_A = G.teams.hometeam.name;
    let TEAM_B = G.teams.awayteam.name;
    const WORD_LIMIT_MOBILE = 12;

    if( this.props.res.isMobilePortrait ){

      let i;
      // A TEAM
      const team_a_parts = TEAM_A.split(' ');

      for(i in team_a_parts){
        team_a_parts[i] = ( team_a_parts[i].length > WORD_LIMIT_MOBILE ) ? team_a_parts[i].substr(0, WORD_LIMIT_MOBILE) + '...' : team_a_parts[i];
      }
      TEAM_A = team_a_parts.join(' ');

      // B TEAM
      const team_b_parts = TEAM_B.split(' ');

      for(i in team_b_parts){
        team_b_parts[i] = ( team_b_parts[i].length > WORD_LIMIT_MOBILE ) ? team_b_parts[i].substr(0, WORD_LIMIT_MOBILE) + '...' : team_b_parts[i];
      }
      TEAM_B = team_b_parts.join(' ');

    }

    // if row has preview attr, then enclose TEAM_A and TEAM_B with an _blank anchor
    if( !this.props.res.isMobilePortrait && !this.props.isExternal && PREVIEW_EXISTS ){
      TEAM_A = (<a href={'https://www.betarades.gr/' + G.preview.slug} target="_blank">{TEAM_A}</a>);
      TEAM_B = (<a href={'https://www.betarades.gr/' + G.preview.slug} target="_blank">{TEAM_B}</a>);
    }

    return(
      <tr
        data-id={G.id}
        onClick={this.props.res.isMobilePortrait ? this.props.onSelectGame : null}
        className={rowClass}>

        <td className="general-cell em comp">
          {this.props.showFlag && <img src={flagsCdn + G.image_name + FLAGS_EXT} alt={G.league_name} width="29" height="22" />}
          {this.props.showFlag && this.props.res.isSmDesktop && G.comp_name}
        </td>

        {!this.props.res.isSmDesktop &&
          <td className="general-cell em comp_name">
            {this.props.showFlag && G.comp_name}
          </td>}

        <td className="time-cell bold time">
          {G.time}
          {this.props.res.isMobile && <span>{G.odds.code}</span>}
        </td>

        {!this.props.res.isMobile &&
          <td className="opap-code-cell bold code">{G.odds.code}</td>}

        {!this.props.res.isMobilePortrait &&
          <td className={"sm mins mins" + G.odds.mins}>{G.odds.mins}</td>}

        {/*<td className="lg odd oddF">{G.odds.odd_1}</td>*/}
        <td className="odd-cell lg odd oddF"><Odd odd={{ c: G.odds.odd_1, p: G.droppingOdds.odd_1 }}/></td>

        <td className={homeTeamClass}>
          {TEAM_A}
          <RedCards data={G.rcards} team={1} />
        </td>

        <td className="odd-cell lg odd oddF"><Odd odd={{ c: G.odds.odd_X, p:G.droppingOdds.odd_X }}/></td>

        <td className={awayTeamClass}>
          <RedCards data={G.rcards} team={2} />
          {TEAM_B}
        </td>

        <td className="odd-cell lg odd oddF divider"><Odd odd={{ c: G.odds.odd_2, p: G.droppingOdds.odd_2 }}/></td>
        {/*goals*/}

        {!this.props.res.isTablet && !this.props.res.isSmDesktop &&
          <td className="odd-cell odd-cell  odd"><Odd odd={{ c: G.odds.odd_u25, p: G.droppingOdds.odd_u25 }}/></td>}
        {!this.props.res.isTablet && !this.props.res.isSmDesktop &&
          <td className="odd-cell odd divider"><Odd odd={{ c: G.odds.odd_o25, p:G.droppingOdds.odd_o25 }}/></td>}

        {/*LIVE*/}
        {!this.props.res.isMobile &&
          <td className='score-cell score ht'>
            {IS_STARTED && !IS_CANCELED ? G.score.ht_goal1 + '-' + G.score.ht_goal2 : ''}
          </td>}

        <td className={liveFTScoreClass}>

          {IS_STARTED && !IS_CANCELED ? G.score.goal1 + '-' + G.score.goal2 : ''}

          {IS_CANCELED ? 'ANAB' : ''}

          {NO_FEED &&
            <i className="fa fa-bell-slash tool" data-tooltip="ΜΟΝΟ ΤΕΛΙΚΟ ΑΠΟΤΕΛΕΣΜΑ"></i>}

          {!this.props.res.isMobile && HAS_EVENTS
            && <Events
                  teams={G.teams}
                  score={G.score}
                  isHT={G.isHT}
                  isLive={G.isLive}
                  min={G.minute}
                  data={G.events} />}

        </td>

        <td className={liveResultClass}>

          {G.isLive
            ? (G.isHT
                ? 'HM'
                : ( G.teams.awayteam.scored || G.teams.hometeam.scored )
                  ? <i className="fa fa-futbol-o fa-spin"></i>
                  : G.minute)
            : (G.isFinished
                ? G.result
                : <i className="fa fa-clock-o"></i>)}

          </td>

          {/*MORE ODDS*/}
          {!this.props.res.isMobile &&
            <td className="general-cell more_odds">

              {/*TEXT*/}
              <button onClick={this.onToggleOdds}>
                +{ G.otherOddsCount - 2 }
                {!this.props.res.isSmDesktop && !this.props.res.isTablet &&
                  <i className={otherOddsBtnClass}></i>}
              </button>

              {/*DROP*/}
              {this.state.oddsDropdownActive &&
                <OddsDropdown
                  game={{ time: G.time, league_name: G.league_name, notIdle: G.isLive || G.isFinished, isFinished: G.isFinished, isLive: G.isLive, isHT: G.isHT }}
                  bookOdds={{fid: G.id, date: G.timestamp}}
                  preview={PREVIEW_EXISTS ? G.preview : null}
                  isExternal={this.props.isExternal}
                  minute={G.minute}
                  score={G.score}
                  odds={G.odds}
                  droppingOdds={G.droppingOdds}
                  teams={G.teams}
                  onCloseOdds={this.handleCloseOdds}/>}

            </td>}

          {!this.props.isStatic &&
            <td className={( this.props.selected ) ? "general-cell  add_fav selected" : "general-cell  add_fav"}
              data-id={G.id}
              onClick={this.props.onSelectGame}>
              <i className="fa fa-star"></i>
            </td>}

      </tr>
    )
  }
};

export default GameRow



// WEBPACK FOOTER //
// ./src/Components/GameRow.js